export interface CountdownProps {
  end: Date;
  start?: Date;
  format?: string;
  minChars?: number;
}

export type TimeUnit = 'DD' | 'HH' | 'MM' | 'SS';

export const UNIT_ORDER: TimeUnit[] = ['DD', 'HH', 'MM', 'SS'];
export const UNIT_SECONDS: Record<TimeUnit, number> = { DD: 86400, HH: 3600, MM: 60, SS: 1 };
export const UNIT_LABEL_KEYS: Record<TimeUnit, string> = {
  DD: 'ui.components.countdown.days',
  HH: 'ui.components.countdown.hours',
  MM: 'ui.components.countdown.minutes',
  SS: 'ui.components.countdown.seconds',
};
